<template>
  <v-dialog :value="open" :width="400" persistent>
    <v-card>
      <v-card-title primary-title class="headline primary--text">{{ title }}</v-card-title>
      <v-card-text>
        <form id="form" @submit="handleSubmit">
          <v-container fluid grid-list-lg class="pa-0 ma-0" :style="{ width: '100% !important' }">
            <v-layout wrap>
              <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('name') }">
                <label class="caption">{{ $t('name') }}</label>
                <input
                  v-model="form.name"
                  v-validate="'required'"
                  name="name"
                  type="text"
                  :disabled="isLoading"
                  :data-vv-as="$t('name')"
                />
                <p v-if="errors.has('name')" class="text-error ma-0">
                  {{ errors.first('name') }}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions :style="{ justifyContent: 'center' }">
        <v-btn outline color="grey" :disabled="isLoading" @click="$emit('update:open', false)">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="primary" :loading="isLoading" type="submit" form="form">{{
          $t('Save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import tigerpolyApi from '@/api/tigerpoly'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: ''
      },
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    title() {
      return this.value ? this.$t('edit_position') : this.$t('add_position')
    }
  },
  watch: {
    open(value) {
      if (value) {
        if (this.value) {
          this.form = {
            name: this.value.name
          }
        } else {
          this.form = {
            name: ''
          }
        }
        this.isLoading = false
        this.$validator.reset()
      }
    }
  },
  methods: {
    async handleSubmit(event) {
      event.preventDefault()

      const isValid = await this.$validator.validate()

      if (!isValid) return

      const { value: isConfirmed } = await this.$swal.fire({
        title: this.$t(this.value ? 'position_edit_question' : 'position_add_question', {
          name: this.form.name
        }),
        type: 'question',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel')
      })

      if (!isConfirmed) return

      try {
        this.isLoading = true

        let response

        if (this.value) {
          response = await tigerpolyApi.putPosition({
            data: {
              id: this.value.id,
              page_id: this.value.page_id,
              ...this.form
            }
          })
        } else {
          response = await tigerpolyApi.postPosition({
            data: {
              page_id: this.selectedBot.pageid,
              ...this.form
            }
          })
        }

        if (response.status === 204) {
          this.$emit('success')
        }
      } catch (error) {
        this.isLoading = false
        if (error.response) {
          this.$swal.fire(error.response.data.message, undefined, 'error')
        }
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/position/FormDialog.vue